import React from 'react'
import {BreadcrumbsItem} from 'wix-ui-tpa/dist/cssVars/types/components'
import {Breadcrumbs as TPABreadcrumbs} from 'wix-ui-tpa/cssVars'

import {useGetLayoutSize} from '../LayoutSizeProvider'
import {Alignment, AlignmentToJustifyContent} from '../../types/createStylesParams'

import {classes, st} from './styles.st.css'

interface BreadcrumbsProps {
  items: BreadcrumbsItem[]
  className?: string
  alignment?: Alignment
}

export const Breadcrumbs = ({items, className, alignment}: BreadcrumbsProps) => {
  const {layoutSize} = useGetLayoutSize()
  const style = alignment
    ? ({
        '--breadcrumbsAlignment': AlignmentToJustifyContent[alignment],
      } as React.CSSProperties)
    : undefined

  return (
    <div className={className} style={style}>
      <TPABreadcrumbs
        className={st('', {[layoutSize]: true}, classes.root)}
        items={items}
        showTrailOnMobileMode
      />
    </div>
  )
}
